// @flow
import { connect } from 'react-redux';

import { pitStatsRequest, pitStatsReset } from 'redux/Pit/actions';
import { stats } from 'redux/Pit/selectors';
import PitDashboard from './PitDashboard.component';
import type { DispatchPropsType, StatePropsType } from './PitDashboard.component';

const mapStateToProps = (state: StoreType): StatePropsType => ({
  stats: stats(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  fetchPitStatsRequest: (pitNumber) => dispatch(pitStatsRequest(pitNumber)),
  pitStatsReset: () => dispatch(pitStatsReset()),
});

export default (connect(mapStateToProps, mapDispatchToProps)(PitDashboard): any);
